import { JoinedCheck, PendingDisplay } from "./index.ts";
import { CONTEST_ENTRY_STATUS } from "utils/constants.ts";
import { ContestEntry } from "interfaces/leaderboard/contest.ts";
import { useAppSelector } from "state/hooks.ts";
import { getCalculatedContestEntryState } from "state/slices/contests-slice.ts";

interface StatusProps {
  contestEntry: ContestEntry;
}

const ContestEntryStatusIcon = ({ contestEntry }: StatusProps) => {
  const calculatedContestEntryState = useAppSelector(state => getCalculatedContestEntryState(state, contestEntry.id));
  const isValid = calculatedContestEntryState?.isValid;

  return (
    <>
      {isValid ? <JoinedCheck /> : <PendingDisplay />}
    </>
  );
};

export default ContestEntryStatusIcon;